<div
	[style.--c]="color"
	[style.--dot.px]="size"
	[style.--line.px]="thickness"
	[style.width]="width"
	class="ornement"
>
	<span class="line"></span>
</div>
